import {Route} from '@angular/router';

export const error401Route: Route = {
    path: '401',
    loadChildren: () => import('./error-401.module').then(m => m.Error401Module)
};
